import { UnitMeasureApiModel } from "@/core/models/api/unit-measure-api-model.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export enum UnitMeasureActionTypes {
  LoadUnitMeasures = 'Load UnitMeasures',
  LoadUnitMeasureSuccess = 'Load UnitMeasure Success',
  LoadUnitMeasureFail = 'Load UnitMeasure Fail',
  AddUnitMeasure = 'Add UnitMeasure',
  AddUnitMeasureSuccess = 'Add UnitMeasure Success',
  UpsertUnitMeasure = 'Upsert UnitMeasure',
  AddUnitMeasures = 'Add UnitMeasures',
  UpsertUnitMeasures = 'Upsert UnitMeasures',
  UpdateUnitMeasure = 'Update UnitMeasure',
  UpdateUnitMeasureSuccess = 'Update UnitMeasure Success',
  UpdateUnitMeasures = 'Update UnitMeasures',
  DeleteUnitMeasure = 'Delete UnitMeasure',
  DeleteUnitMeasures = 'Delete UnitMeasures',
  ClearUnitMeasures = 'Clear UnitMeasures'
}

export const UnitMeasureActions = createActionGroup({
    source: 'UnitMeasure',
    events: {
        [UnitMeasureActionTypes.LoadUnitMeasures]: emptyProps(),
        [UnitMeasureActionTypes.LoadUnitMeasureSuccess]: props<{ unitMeasures: UnitMeasureApiModel[] }>(),
        [UnitMeasureActionTypes.LoadUnitMeasureFail]: props<{ error: string }>(),
        [UnitMeasureActionTypes.AddUnitMeasureSuccess]: props<{ unitMeasure: UnitMeasureApiModel }>(),
        [UnitMeasureActionTypes.AddUnitMeasure]: props<{ unitMeasure: UnitMeasureApiModel }>(),
        [UnitMeasureActionTypes.UpdateUnitMeasure]: props<{ unitMeasure: UnitMeasureApiModel }>(),
        [UnitMeasureActionTypes.UpdateUnitMeasureSuccess]: props<{ unitMeasure: UnitMeasureApiModel }>(),
        [UnitMeasureActionTypes.DeleteUnitMeasure]: props<{ unitMeasureId: number }>(),
        [UnitMeasureActionTypes.ClearUnitMeasures]: emptyProps()
    }
});